import { useState } from 'react';
import { getPurchasesTableColumns } from '../../utils';
import { usePurchases } from '../../hooks';
import { PageWidget } from '@components/PageWidget';
import { Table } from '@/Table';
import { Spinner } from '@components/Spinner';

function HistoryTab() {
  const columns = getPurchasesTableColumns();
  const [cursor, setCursor] = useState<string>('');
  const { data, isLoading } = usePurchases({ cursor });

  return (
    <PageWidget title='Transactions' fullWidth={true}>
      {!isLoading ? (
        <>
          {data.data?.length ? (
            <Table
              data={data.data}
              columns={columns}
              metadata={data.metadata}
              onPageChange={(cursor: string) => {
                setCursor(cursor);
              }}
            />
          ) : (
            <p>You have no transactions.</p>
          )}
        </>
      ) : (
        <Spinner variant='small' />
      )}
    </PageWidget>
  );
}

export { HistoryTab };
